import { useState } from 'react';
import { formatTimestamp } from '../../utils/time';
import { coordsToFrequency } from '../../utils/frequency';
import type { PublicMessage } from '../../types';
import UserDetailModal from './UserDetailModal';

interface Props {
  message: PublicMessage;
  onClose: () => void;
}

export default function MessageDetailModal({ message, onClose }: Props) {
  const [showUser, setShowUser] = useState(false);

  const freq = coordsToFrequency(message.lat, message.lng);
  const userType = message.isBot ? '봇' : message.isNearbyNotification ? '시스템' : '일반회원';

  return (
    <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
        <div className="bg-white rounded-xl p-6 max-w-lg w-full mx-4" onClick={e => e.stopPropagation()}>
          <h3 className="font-bold mb-4">메세지 세부정보</h3>

          <div className="space-y-2 text-sm">
            <div className="bg-gray-50 rounded-lg p-4 space-y-1.5">
              <div><span className="text-gray-500">발신자:</span> <button onClick={() => setShowUser(true)} className="text-blue-600 hover:underline font-medium">{message.senderNickname}</button></div>
              <div><span className="text-gray-500">성별:</span> {message.gender}</div>
              <div><span className="text-gray-500">사용자 유형:</span> {userType}</div>
              <div><span className="text-gray-500">메세지:</span> {message.text}</div>
              <div><span className="text-gray-500">주파수:</span> <span className="font-mono">{freq}</span></div>
              <div><span className="text-gray-500">발신시간:</span> {formatTimestamp(message.timestamp)}</div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 space-y-1.5">
              <div><span className="text-gray-500">발신자 ID:</span> <span className="font-mono text-xs break-all">{message.senderId}</span></div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 space-y-1.5">
              <h4 className="font-semibold text-gray-700">위치 정보:</h4>
              <div><span className="text-gray-500">위도:</span> {message.lat?.toFixed(6)}</div>
              <div><span className="text-gray-500">경도:</span> {message.lng?.toFixed(6)}</div>
              <div><span className="text-gray-500">반경:</span> {(message.radius || 0).toLocaleString()}m</div>
              <div><span className="text-gray-500">수동주파수:</span> {message.manualFreqApplied ? '예' : '아니오'}</div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 space-y-1.5">
              <h4 className="font-semibold text-gray-700">네트워크/추적 정보:</h4>
              <div><span className="text-gray-500">타임스탬프:</span> {message.timestamp?.toDate?.()?.toISOString() ?? 'N/A'}</div>
              <div><span className="text-gray-500">문서 ID:</span> <span className="font-mono text-xs">{message.id}</span></div>
            </div>
          </div>

          <div className="mt-4 flex gap-2">
            <button onClick={() => setShowUser(true)} className="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 border border-blue-200 rounded">사용자 정보 조회</button>
            <button onClick={onClose} className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded">닫기</button>
          </div>
        </div>
      </div>

      {showUser && <UserDetailModal uid={message.senderId} onClose={() => setShowUser(false)} />}
    </>
  );
}
